import { PivotTableProps } from 'components/pivot-table/PivotTable'

import { KeyMapping, keyMappings } from '../common/keyMapping-relatorioGerencial'
import { VisibilidadeModeloPersonalizadoEnum } from '../components/modelo-personalizado/form/model-modeloPersonalizadoRelatorioGerencialForm'
import {
  CboPrescritorRelatorioGerencialVacinacaoSelectFieldDocument,
  Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldDocument,
  CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryDocument,
  DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument,
  EstrategiaRelatorioGerencialVacinacaoSelectFieldDocument,
  ImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument,
  LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryDocument,
  SimNaoNaoInformadoRelatorioGerencialSelectFieldDocument,
  SimNaoRelatorioGerencialSelectFieldDocument,
  ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryDocument,
} from './../../../../graphql/hooks.generated'
import { RelatorioGerencialVacinacaoModel } from './model-relatorioGerencialVacinacao'

const doseKeyMapping: KeyMapping = {
  keyName: 'Dose',
  formatter: (s: string) => s?.capitalize(),
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument,
  },
}

const condicaoMaternalKeyMapping: KeyMapping = {
  keyName: 'Condição Maternal',
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: CondicaoMaternalRelatorioGerencialVacinacaoSelectFieldQueryDocument,
  },
}

const estrategiaVacinacaoKeyMapping: KeyMapping = {
  keyName: 'Estratégia',
  formatter: (s: string) => s?.capitalize(),
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: EstrategiaRelatorioGerencialVacinacaoSelectFieldDocument,
  },
}

const viajanteKeyMapping: KeyMapping = {
  keyName: 'Viajante',
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: SimNaoNaoInformadoRelatorioGerencialSelectFieldDocument,
  },
}

const imunobiologicoKeyMapping: KeyMapping = {
  keyName: 'Imunobiológico',
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: ImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument,
  },
}

const viaAdministracaoKeyMapping: KeyMapping = {
  keyName: 'Via de Administração',
  formatter: (s: string) => s?.capitalize(),
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: ViaAdministracaoRelatorioGerencialVacinacaoSelectFieldQueryDocument,
  },
}

const localAplicacaoKeyMapping: KeyMapping = {
  keyName: 'Local de Aplicação',
  formatter: (s: string) => s?.capitalize(),
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: LocalAplicacaoRelatorioGerencialVacinacaoSelectFieldQueryDocument,
  },
}

const cboPrescritorKeyMapping: KeyMapping = {
  keyName: 'Profissional Prescritor',
  formatter: (s: string) => s?.capitalize(),
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: CboPrescritorRelatorioGerencialVacinacaoSelectFieldDocument,
  },
}

const cid10MotivoIndicacaoKeyMapping: KeyMapping = {
  keyName: 'Motivo de Indicação',
  formatter: (s: string) => s?.capitalize(),
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: Cid10MotivoIndicacaoRelatorioGerencialVacinacaoSelectFieldDocument,
  },
}

const stPesquisaClinicaKeyMapping: KeyMapping = {
  keyName: 'Pesquisa Clínica',
  modelo: {
    visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
    queryDocument: SimNaoRelatorioGerencialSelectFieldDocument,
  },
}

export const vacinacaoKeyMapping: PivotTableProps<RelatorioGerencialVacinacaoModel>['keyMapping'] = new Map<
  keyof RelatorioGerencialVacinacaoModel,
  KeyMapping
>([
  ['dose', doseKeyMapping],
  ['imunobiologico', imunobiologicoKeyMapping],
  ['municipio', keyMappings.municipio],
  ['unidadeSaude', keyMappings.unidadeSaude],
  ['nomeProfissional', keyMappings.nomeProfissional],
  ['categoriaProfissional', keyMappings.categoriaProfissional],
  ['equipe', keyMappings.equipe],
  ['turno', keyMappings.turno],
  ['sexo', keyMappings.sexo],
  ['dia', keyMappings.dia],
  ['mes', keyMappings.mes],
  ['hora', keyMappings.hora],
  ['semana', keyMappings.semana],
  ['diaSemana', keyMappings.diaDaSemana],
  ['faixaEtaria', keyMappings.faixaEtaria],
  ['condicaoMaternal', condicaoMaternalKeyMapping],
  ['estrategiaVacinacao', estrategiaVacinacaoKeyMapping],
  ['viajante', viajanteKeyMapping],
  ['cbo', keyMappings.cbo],
  ['producoes', keyMappings.producoes],
  ['viaAdministracao', viaAdministracaoKeyMapping],
  ['localAplicacao', localAplicacaoKeyMapping],
  ['cboPrescritor', cboPrescritorKeyMapping],
  ['cid10MotivoIndicacao', cid10MotivoIndicacaoKeyMapping],
  ['stPesquisaClinica', stPesquisaClinicaKeyMapping],
])
